exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2erxbVDXUc4DK0SRnh1Cb8>:not(:first-child){margin-top:1em}", ""]);

// exports
exports.locals = {
	"dialogContent": "_2erxbVDXUc4DK0SRnh1Cb8"
};